// extracted by mini-css-extract-plugin
export default {"Music":"Music_Music__Of0B9","Btns":"Music_Btns__uMfC2"};